import PropTypes from 'prop-types';

export const SubjectPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]);
